























import { Component, Vue } from 'vue-property-decorator'
import CommTable from './CommTable.vue'
import FacebookTable from './FacebookTable.vue'
import GoogleTable from './GoogleTable.vue'
import SummaryTable from './SummaryTable.vue'
import TransactionTable from './TransactionTable.vue'
import { UserSearch } from './types/user-search'


const reports = [
    { key: 'summary', name: 'Summary', component: SummaryTable },
    { key: 'transaction', name: 'Transaction', component: TransactionTable },
    { key: 'google', name: 'Google', component: GoogleTable },
    { key: 'facebook', name: 'Facebook', component: FacebookTable },
    { key: 'comm', name: 'Comm', component: CommTable }
]


@Component({
    components: {
        SummaryTable,
        TransactionTable,
        GoogleTable,
        FacebookTable,
        CommTable
    }
})
export default class FranchiseReporting extends Vue {
    accountId: number|null = null
    beginDate: string|null = null
    fromDate: string|null = null
    toDate: string|null = null
    reports = reports
    accountIdOptions = [
        { text: 'Authority Brands - Multiple Franchises', value: 56 },
        { text: 'AB - One Hour Air', value: 1250 },
        { text: 'AB - Benjamin Franklin', value: 1230 },
        { text: 'AB - Mister Sparky', value: 1229 },
        { text: 'Mosquito Squad', value: 1073 },
        { text: 'Mosquito Squad (Chicago)', value: 1034 },
        { text: 'Mosquito Squad (Greater DC)', value: 1072 },
        { text: 'ASP', value: 1167 },
        { text: 'Shelf Genie', value: 2 },
        { text: 'EcoPlumbers', value: 26 },
        { text: 'Cleaning Authority', value: 1277 },
        { text: 'Alden Network', value: 1303 },
        { text: 'Hello Garage', value: 1251 },
        { text: 'Rooter Hero Plumbing', value: 1369 },
        { text: 'Best Home Services/Frank Gay Services', value: 794 },
        { text: 'Mold Inspection Services', value: 1377 },
        { text: 'Monster Tree', value: 1508 },
        { text: 'Air Pros', value: 1509 },
        { text: 'Service Champions', value: 97 },
        { text: 'Pediatric Home Services', value: 1575 },
        { text: 'DoodyCalls', value: 1618 },
        { text: 'bluefrog Plumbing + Drain', value: 1697 },
        { text: 'Homewatch CareGivers', value: 1957 },
        { text: 'STOP Restoration', value: 1970 },
        { text: 'Legacy Service Partners', value: 1995 },
        { text: 'Granite Comfort', value: 2051 },
        { text: 'Family Home Health Network', value: 2143 },
        { text: 'Southern Home Services', value: 2146 },
        { text: 'Right-Time', value: 2335 },
        { text: 'Clarion Home Services', value: 2349 }
    ]

    esSearchOptions = [
        { text: 'Custom Date Range', value: 'custom' },
        { text: 'Now - 1 Day', value: 'now-1d/d' },
        { text: 'Now - 7 Days', value: 'now-7d/d' },
        { text: 'Now - 1 Months', value: 'now-1M/d' },
        { text: 'Now - 3 Months', value: 'now-3M/d' },
        { text: 'Now - 6 Months', value: 'now-6M/d' },
        { text: 'Now - 12 Months', value: 'now-12M/d' },
        { text: 'Now - 24 Months', value: 'now-24M/d' }
    ]

    get loadReportPayload(): UserSearch {
        return {
            accountId: this.accountId as number,
            beginDate: this.beginDate as string,
            fromDate: this.fromDate as string,
            toDate: this.toDate as string
        }
    }
}
